<template>
  
</template>

<script>
export default {
    created: function() {
        this.$router.push("/az");
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/AZ/Main.vue